export default __webpack_public_path__ + "static/media/03_Icono Foto Perfil.7324cc0c.svg";